module.exports = __webpack_public_path__ + "3610935577098a10b62a93f54e49446f.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/map-marker.svg
// module id = ldGe
// module chunks = 5